import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

import { Img } from 'component/FrameL';

import Loader from 'component/Loader';

export default ({ match }) => {

    const [cmsData, setCmsData] = useState(null);
    let Name = match.params.name;
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_DOMAIN}/custom-pages/${Name}`)
            .then(response => response.json())
            .then(data => {
                setCmsData(data);
            }).catch(error => {
                console.log('Something went wrong');
            })
    }, []);

    if (!cmsData) {
        return <Loader></Loader>
    }

    const { heroImage = {}, introduction = {}, middle, images = [] } = cmsData;
    const { photo, heading, description } = introduction;

    return <main style={{ "--space": "var(--s5)" }} className="stack-l xl:container mx-auto px-4 pb-10">
        <section className="break-out-banner">
            <Img className='w-full' Image={heroImage}></Img>
        </section>

        <section>
            <div className='sidebar-l-right px-4' style={{ '--sideWidth': '400px' }}>
                <div>
                    <h3 className='text-5xl text-accent text-center'>{heading}</h3>
                    <ReactMarkdown>{description}</ReactMarkdown>
                </div>
                <div>
                    <Img Image={photo}></Img>
                </div>
            </div>
        </section>

        <section className='bg-gray-300 break-out-banner'>
            <ReactMarkdown className='mx-auto xl:container px-4 py-16'>{middle}</ReactMarkdown>
        </section>

        <section className='max-w-screen-md mx-auto'>
            <div className='stack-l' style={{ "--space": "var(--s2)" }}>
                {images.map((Image, i) => {
                    return <Img key={i} Image={Image}></Img>
                })}
            </div>
        </section>
    </main >
}